import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string | number {
    if (!value) return '';

    const birthDate = moment.utc(value);

    if (!birthDate.isValid()) return '';

    return moment().diff(birthDate, 'years');
  }
}
